import type { ButtonHTMLAttributes } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useThemeStore } from '../../../stores';
import styles from './ThemeToggle.module.css';

interface ThemeToggleProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  className?: string;
}

export const ThemeToggle = ({ className = '', ...props }: ThemeToggleProps) => {
  const { theme, toggleTheme } = useThemeStore();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className={`${styles.toggle} ${className}`}
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      {...props}
    >
      <div className={styles.iconWrapper}>
        <Sun 
          className={`${styles.icon} ${styles.sun} ${!isDark ? styles.active : ''}`}
          size={20}
          strokeWidth={2}
        />
        <Moon 
          className={`${styles.icon} ${styles.moon} ${isDark ? styles.active : ''}`}
          size={20}
          strokeWidth={2}
        />
      </div>
    </button>
  );
};
